module.exports = __webpack_public_path__ + "images/Zoom-b6dd76.png";